import React, { Component } from 'react'
import sendVerificationEmail from '../sendVerificationEmail'
import emailConfirmedInFirebase from '../emailConfirmedInFirebase'
import Card from './styled-components/Card'
import HeaderText from './styled-components/HeaderText'
import HeaderTextSmall from './styled-components/HeaderTextSmall'
import { ButtonPrimaryWide, ButtonSecondaryWide } from './styled-components/Button'
import EmailText from './EmailText'
import { AnovaLogoSmall } from './AnovaLogo'
import TextColumn from './styled-components/TextColumn'
import ButtonColumn from './styled-components/ButtonColumn'
import ToastMessage from './ToastMessage'
import getFirebaseJWTForCurrentUser from '../getFirebaseJWTForCurrentUser'
import authenticateAnovaIdentity from '../authenticateAnovaIdentity'
import addOutgoingParamsToRedirectURL from '../addOutgoingParamsToRedirectURL'
import getEmailFromLocalStorage from '../getEmailFromLocalStorage'
import redirectToURL from '../redirectToURL'
import { analyticsPage } from '../analytics'

class VerifyEmailPending extends Component {
  state = {
    shouldShowErrorToast: false,
    shouldShowEmailResentToast: false
  }

  checkEmailConfirmation = async (isInitiatedByUser) => {
    const emailConfirmed = await emailConfirmedInFirebase()

    if (emailConfirmed) {
      const firebaseJWT = await getFirebaseJWTForCurrentUser()
      const anovaJWT = await authenticateAnovaIdentity(firebaseJWT)
      const redirectURLWithOutgoingParams = addOutgoingParamsToRedirectURL(
        this.props.redirectURI,
        anovaJWT,
        this.props.oAuthStateParameter,
        this.props.clientID
      )

      redirectToURL(redirectURLWithOutgoingParams)
    } else if (isInitiatedByUser) {
      this.setState({ shouldShowErrorToast: true })
    }
  }

  resendVerificationEmail = async () => {
    await sendVerificationEmail(this.props.redirectURI)
    this.setState({ shouldShowEmailResentToast: true })
  }

  toastMessage = () => {
    if (this.state.shouldShowErrorToast) {
      return 'Your email address is not yet confirmed. Check your email inbox for instructions.'
    } else {
      return 'Email sent!'
    }
  }

  dismissToastMessage = () => {
    this.setState({
      shouldShowErrorToast: false,
      shouldShowEmailResentToast: false
    })
  }

  componentDidMount () {
    analyticsPage('ALI Log In - Email Verification Pending')

    this.checkEmailConfirmationTimer = setInterval(() => this.checkEmailConfirmation(false), 15000)
  }

  componentWillUnmount () {
    clearInterval(this.checkEmailConfirmationTimer)
  }

  render () {
    return (
      <Card data-email-confirmation-pending>
        {
          this.state.shouldShowErrorToast || this.state.shouldShowEmailResentToast
            ? <ToastMessage
              messageText={this.toastMessage()}
              dismissToastMessage={this.dismissToastMessage}
            />
            : null
        }

        <div>
          <AnovaLogoSmall />
        </div>

        <TextColumn>
          <HeaderText>Check your email</HeaderText>
          <HeaderTextSmall>
            Follow the instructions sent to<br />
            <EmailText email={this.props.email || getEmailFromLocalStorage() || ''} />
            &nbsp;to confirm your email address.
          </HeaderTextSmall>
        </TextColumn>

        <ButtonColumn>
          <ButtonPrimaryWide
            onClick={() => this.checkEmailConfirmation(true)}
            data-check-email-verification-button>
            CHECK MY CONFIRMATION
          </ButtonPrimaryWide>
          <ButtonSecondaryWide
            onClick={this.resendVerificationEmail}
            data-resend-verification-email-button>
            RESEND CONFIRMATION EMAIL
          </ButtonSecondaryWide>
        </ButtonColumn>
      </Card >
    )
  }
}

export default VerifyEmailPending
